/**
 * URL constants used throughout the app
 */

export const URLS = {
  CODE_OF_CONDUCT: 'https://intercom.help/cobu/en/articles/4342107-code-of-conduct',
  SUPPORT: 'https://intercom.help/cobu/en/',
  DEFAULT_PROFILE_IMAGE: 'https://s3.amazonaws.com/doorbell-test1/c222370d196a41282aad2672b3c37e31_profile.png',
  PREVIEW_PROFILE_IMAGE: 'https://doorbell-test1.s3.amazonaws.com/cobu_assets/profile.png',
  CHAT: 'https://cobu-static-assets.s3.amazonaws.com/chat.png',
  EVENTS: 'https://cobu-static-assets.s3.amazonaws.com/events.png',
  MARKETPLACE: 'https://cobu-static-assets.s3.amazonaws.com/colab.png',
  GROUP_PLACEHOLDER_IMAGE: 'https://www.flynz.co.nz/wp-content/uploads/profile-placeholder.png',
  ROBOT_AVATAR: 'https://placeimg.com/140/140/any',
  APP_STORE: 'https://apps.apple.com/us/app/cobu-power-genuine-community/id1280724094',
  PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.doorbell_react_native',
  DEFAULT_MERCHANT_IMAGE: 'https://s3.amazonaws.com/cobu-static-assets/merchant_placeholder.jpg',
} as const; 
